<template>
  <div class = "api-module api-mlp-compat-phone">
    <p class = "description">
      Here you can simulate how a person can interact with the screen using the mobile phone.
    </p>

    <div class = "phones">
      <div v-for = "i in 3" :key = "i" class = "phone">
        <div class = "screen" v-on:click = "sendClick(i)"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ApiMlpCompatPhone',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    sendClick: function (id) {
      this.$eventHub.$emit('rtdata', { from: 'onPhoneClicked', value: id })
    }
  },
  mounted () {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.api-mlp-compat-phone {
}

.phones {
  display: flex;
  align-self: center;
}

.phone {
  background: @accentColor;
  width: 52px;
  height: 80px;
  border-radius: 2px;
  box-shadow: 0px 0px 5px 1px #0005;
  margin: 10px;

  .screen {
    margin-top: 4px;
    margin-left: 4px;
    background: #222;
    width: 44px;
    height: 65px;

    &:hover {
      background: #555;
    }

    &:active {
      background: #888;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ApiModules/ApiMlpPhone.vue